var __rspack_ns_object = JSON.parse('{"buttons":{"backToHome":"Back To Home"}}')